export const openUrl=(url:string)=>{
    window.open('http://'+url);
}